import mitt from "mitt"

/**
 * Small event bus the rest of Peanuts can use to make the monkey react to
 * what happens in the application, without knowing anything about the monkey.
 */
export type MonkeyEvents = {
  /** Something went well: the monkey cheers. */
  celebrate: { text?: string } | undefined
  /** Something went wrong: the monkey is startled. */
  startle: { text?: string } | undefined
}

export const monkeyEvents = mitt<MonkeyEvents>()
